import { withTogglePointFactory } from "@asosteam/asos-web-toggle-point-cuts";
import { pointCutPluginFactory } from "@asosteam/asos-web-toggle-point-optimizely";
import sdkInstanceProvider from "../../../client/sdkProvider";
import logger from "../../../lib/logger";
import { LOG_LEVEL_ERROR } from "../../../lib/logger/constants";
import { getFeatures } from "../../../featuresStore";
import useGuidedSearchActivationFeatures, {
  GUIDED_SEARCH_FEATURE,
} from "./useGuidedSearchActivationFeatures";

const plugin = pointCutPluginFactory({
  sdkInstanceProvider,
  getAudience: () => getFeatures()?.audience,
});

const useActivateFeatures = plugin.onCodeSelected;
const useGuidedSearchActivation = (params) => {
  const matchedFeatures = useGuidedSearchActivationFeatures(
    params.matchedFeatures,
  );

  useActivateFeatures({ ...params, matchedFeatures });
};

const getTogglePoint = (activationPlugin) =>
  withTogglePointFactory({
    getActiveFeatures: () => getFeatures()?.decisions,
    logError: logger[LOG_LEVEL_ERROR],
    plugins: [activationPlugin],
  });

const withTogglePointFromFactory = getTogglePoint(plugin);
// Gate exposure, not page selection: switching page variants resets filter state.
const withGuidedSearchTogglePoint = getTogglePoint({
  ...plugin,
  onCodeSelected: useGuidedSearchActivation,
});

const REACT_COMPONENT_STATICS = [
  "arguments",
  "caller",
  "length",
  "name",
  "prototype",
];

const copyStaticProperties = ({ Component, source }) => {
  Object.getOwnPropertyNames(source)
    .filter(
      (propertyName) =>
        !REACT_COMPONENT_STATICS.includes(propertyName) &&
        !Object.prototype.hasOwnProperty.call(Component, propertyName),
    )
    .forEach((propertyName) => {
      Object.defineProperty(
        Component,
        propertyName,
        Object.getOwnPropertyDescriptor(source, propertyName),
      );
    });
};

const withTogglePoint = (controlModule, featuresMap) => {
  const createTogglePoint = featuresMap?.has?.(GUIDED_SEARCH_FEATURE)
    ? withGuidedSearchTogglePoint
    : withTogglePointFromFactory;
  const Component = createTogglePoint(controlModule, featuresMap);

  if (Component && controlModule?.default) {
    copyStaticProperties({ Component, source: controlModule.default });
  }

  return Component;
};

export default withTogglePoint;
